/* eslint-disable */
import React from "react";

const Footer = () => {
   return (
      <div className="footer">
         <div className="copyright">
            <p>
               Copyright &copy;{" "}
               <a href="https://drhaynescollective.com/" target="_blank">
                  Dr. Haynes Collective
               </a>{" "}
               {new Date().getFullYear()}
            </p>
         </div>
      </div>
   );
};

export default Footer;
